/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { AnyAction } from 'redux';
import UPDATE_DICOM from '../../../constants/dicom.constants';
import { AUTH_LOGOUT } from '../../../constants/auth.constants';
import DicomState from '../../../models/redux/state/dicom.state';

const initialState: DicomState = {};

const dicomReducer = produce((draft: DicomState, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_DICOM:
      draft[action.index] = action.dicom;
      break;
    case AUTH_LOGOUT:
      draft = initialState;
      break;
    default:
  }
}, initialState);

export default dicomReducer;
